import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Flashcard } from 'src/app/entities/wordcard.model';
import { Observable } from 'rxjs';
import { FlashcardService } from 'src/app/services/flashcard.service';
import { TextToSpeechService } from 'src/app/services/text-to-speech.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-study-card',
  standalone: true,
  imports: [IonicModule, CommonModule, RouterModule, TranslateModule],
  templateUrl: './study-card.page.html',
  styleUrls: ['./study-card.page.scss']
})
export class StudyCardPage implements OnInit {
  flashcard: Flashcard | null = null;
  showBack = false;
  loadingAudio = false;

  constructor(
    private route: ActivatedRoute,
    private flashCardService: FlashcardService,
    private router: Router,
    private textToSpeechService: TextToSpeechService
  ) {}

  ngOnInit() {
    document.title = 'Learn';
    this.route.paramMap.subscribe(params => {
      const cardId = params.get('id');
      if (cardId) {
        this.showBack = false; // Reset to front when loading a new card
        const supportedLanguages = ['en', 'ru', 'es', 'fr', 'de', 'ar', 'hi', 'ja', 'pt', 'zh']; // Add your supported languages here
        if (supportedLanguages.includes(cardId)) {
          this.flashCardService.generateDefaultCard(cardId).then(defaultCard => {
            this.flashcard = defaultCard;
          });
        }
        else {
          this.flashCardService.getFlashCardById(cardId).subscribe(card => {
          this.flashcard = card || null;
        });
        }
      }
    });
  }

  flip() {
    this.showBack = !this.showBack;
  }

  // Placeholder handlers for the answer buttons
  onAnswer(answer: 2 | 3 | 4 | 5) {
    if (this.flashcard) {
      // TODO: Implement spaced repetition logic and move to next card
    this.flashCardService.onAnswer(this.flashcard, answer).then(() => {
        // Go to the next card
        let nextCard = this.flashCardService.goToNextCard();
        if (nextCard) {
          this.router.navigate(['/study', nextCard.id]);
        } else {
          // If no next card, navigate back to the study page
          this.router.navigate(['/study']);
        }
      }
      ).catch(err => {
        console.error('Error processing answer:', err);
        // Optionally show an error message to the user
      }
      );
    }
  }

  /**
   * Vocalize the current flashcard using text-to-speech
   */
  async vocalize(): Promise<void> {
    if (!this.flashcard) {
      console.error('No flashcard to vocalize');
      return;
    }

    this.loadingAudio = true;
    
    try {
      const targetLanguage = this.flashcard.targetLanguage || 'en';
      await this.textToSpeechService.vocalizeWordCard(this.flashcard, targetLanguage);
    } catch (error) {
      console.error('Error vocalizing flashcard:', error);
    } finally {
      this.loadingAudio = false;
    }
  }

  /**
   * Stop audio playback
   */
  stopAudio(): void {
    this.textToSpeechService.stopCurrentAudio();
  }

  /**
   * Check if audio is currently playing
   */
  isAudioPlaying(): boolean {
    return this.textToSpeechService.isCurrentlyPlaying();
  }
}